import React from "react";
import "./Projects.css";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "Smart Home Automation",
      description: "IoT-based system for controlling home appliances remotely using Arduino and MQTT protocol.",
      tech: ["Arduino", "IoT", "MQTT", "React"],
      image: "https://images.unsplash.com/photo-1558002038-1055907df827?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
    },
    {
      id: 2,
      title: "E-Learning Platform",
      description: "Full-stack educational platform with video streaming, quizzes, and progress tracking.",
      tech: ["React", "Node.js", "MongoDB", "WebRTC"],
      image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1074&q=80",
    },
    {
      id: 3,
      title: "AI Chatbot Assistant",
      description: "Intelligent chatbot using NLP to answer student queries and provide academic support.",
      tech: ["Python", "NLP", "Flask", "React"],
      image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
    },
    {
      id: 4,
      title: "Blockchain Voting System",
      description: "Decentralized voting application ensuring transparency and security using blockchain.",
      tech: ["Solidity", "Ethereum", "React", "Web3.js"],
      image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
    },
  ];

  return (
    <section className="projects">
      <div className="projects-container">
        <h1 className="page-title">My Projects</h1>
        <div className="projects-grid">
          {projects.map((project) => (
            <div className="project-card" key={project.id}>
              <div className="project-image">
                <img src={project.image} alt={project.title} />
              </div>
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="tech-tags">
                  {project.tech.map((tech, index) => (
                    <span className="tech-tag" key={index}>{tech}</span>
                  ))}
                </div>
                <div className="project-links">
                  <a href="#"><FaGithub /> Code</a>
                  <a href="#"><FaExternalLinkAlt /> Demo</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;